<template>
  <Heading :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridHeadingEditor",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
